import { render } from "./BaseLayout.vue?vue&type=template&id=26455374&scoped=true"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"

import "./BaseLayout.vue?vue&type=style&index=0&id=26455374&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-26455374"

export default script